import { IconWatermarkDiagonalRight } from '@picsart/design-system/foundation/icons/IconWatermarkDiagonalRight';
import { IconWatermarkDiagonalLeft } from '@picsart/design-system/foundation/icons/IconWatermarkDiagonalLeft';
import { IconPositionTopLeft } from '@picsart/design-system/foundation/icons/IconPositionTopLeft';
import { IconPositionTopRight } from '@picsart/design-system/foundation/icons/IconPositionTopRight';
import { IconPositionDownRight } from '@picsart/design-system/foundation/icons/IconPositionDownRight';
import { IconPositionDownLeft } from '@picsart/design-system/foundation/icons/IconPositionDownLeft';

import { WatermarksPositions } from 'pages/Batch/utils/watermark/configs';
import type { IWatermarkAttrs } from 'pages/Batch/types';

export const WatermarkPositionsIconList = [
  {
    name: 'Top L',
    icon: IconPositionTopLeft,
    id: WatermarksPositions.LEFT_TOP,
  },
  {
    name: 'Top R',
    icon: IconPositionTopRight,
    id: WatermarksPositions.RIGHT_TOP,
  },
  {
    name: 'Bottom L',
    icon: IconPositionDownLeft,
    id: WatermarksPositions.LEFT_BOTTOM,
  },
  {
    name: 'Bottom R',
    icon: IconPositionDownRight,
    id: WatermarksPositions.RIGHT_BOTTOM,
  },
  {
    name: 'Full L',
    icon: IconWatermarkDiagonalRight,
    id: WatermarksPositions.RIGHT_FULL,
  },
  {
    name: 'Full R',
    icon: IconWatermarkDiagonalLeft,
    id: WatermarksPositions.LEFT_FULL,
  },
] as const;

export const numberOfImageFrames = 1;

export const DEFAULT_WATERMARK_ATTRS: IWatermarkAttrs = {
  position: WatermarksPositions.LEFT_TOP,
  opacity: 100,
  size: 30,
  rotateAngle: 0,
  statusIndicatorMode: 'doneOnly',
};

export const WATERMARK_ANGLES_CONFIG: Record<string, number> = {
  [WatermarksPositions.RIGHT_FULL]: 45,
  [WatermarksPositions.LEFT_FULL]: -45,
};
